var _g, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6787 8.56883C18.8083 17.6193 2.49603 21.2396 0.683594 8.56883C0.683594 -0.481677 16.8663 -4.23117 18.6787 8.56883Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4836 11.7618V9.17598C10.5094 8.82973 10.4448 8.48202 10.3024 8.16744C10.2636 8.04254 10.1859 7.93063 10.0951 7.84218C9.99173 7.75388 9.8752 7.69219 9.74578 7.66323C9.59051 7.57026 9.40918 7.53794 9.2409 7.57271C9.04663 7.67615 8.93005 7.63736 8.82635 7.88301V12.5246C8.73578 12.7832 9.00764 13.0289 9.27948 13.1194C9.55145 13.2099 9.46074 13.1194 9.55145 13.197C9.77143 13.204 9.99154 13.1778 10.1987 13.1194L10.2892 13.0289C10.4057 12.885 10.4706 12.708 10.4706 12.5246V11.6842L10.4836 11.7618Z",
    fill: "#09366B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20503 5.52716C8.174 5.18939 8.26722 4.85206 8.48433 4.58502C8.69105 4.31796 8.99087 4.14163 9.33198 4.09253C9.66294 4.04343 10.0144 4.12535 10.2832 4.32129C10.5623 4.51723 10.7589 4.81223 10.821 5.14514C10.852 5.4829 10.7588 5.82014 10.5417 6.08728C10.335 6.35431 10.0352 6.53067 9.69405 6.57971C9.36309 6.62886 9.0218 6.547 8.74263 6.35101C8.46346 6.15502 8.26721 5.86007 8.20503 5.52716Z",
    fill: "#09366B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.8f8e60ca1f4f87ff73d779e3f88aa4a8.svg";
export { ForwardRef as ReactComponent };